export default __webpack_public_path__ + "static/media/OLED_NEW.6a3f9a6c.png";